import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const { token, pin_token } = authService.getTokens;

  // If the request already has an Authorization header (e.g. login request), don't overwrite it
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  if (token && pin_token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'pin-token': pin_token
      }
    });
    return next(authReq);
  }

  return next(req);
};